<template>
  <div>
    <div class="app">
      <div>
        <div class="left">
          <div
            :style="{ background: 'url(' + require('../../assets/' + cardMsg['img']) + ') no-repeat center center', backgroundSize: '100% 100%'}"
          ></div>
        </div>
        <div class="right">
          <div class="title">
            <h3 class v-for="(item, index) in cardMsg['h3']" :key="index">{{item}}</h3>
            <p class v-for="(item, index) in cardMsg['p']" :key="index">{{item}}</p>
          </div>
          <div class="context">
            <div v-for="(item, index) in cardMsg['li']" :key="index" class="item-core">
              <div></div>
              <div>
                <p>{{item}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    cardMsg: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  }
}
</script>

<style scoped>
.app {
  width: 958px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 6px 18px 2px rgba(167, 167, 167, 0.2);
}

.left {
  width: 200px;
  height: 100%;
  margin: 0 auto;
}
.left div {
  font-size: 24px;
  font-weight: bold;
  width: 140px;
  margin-top: 15px;
  height: 140px;
}
.right {
  width: 800px;
  height: 100%;
  margin-right: 56px;
}
.title {
  height: 156px;
  padding-top: 41px;
  margin-left: 95px;
  border-bottom: 1px solid rgba(226, 223, 223, 1);
}

.title h3 {
  font-size: 24px;
  font-weight: bold;
  text-align: left;
}
.title p {
  font-size: 18px;
  font-weight: normal;
  margin-top: 0px;
  text-align: left;
}
.context {
  padding-left: 0px;
  margin-left: 58px;
}
.context .item-core {
  text-align: left;
  margin-top: 10px;
  margin-left: 33px;
  width: 350px;
}
.context > :first-child {
  margin-top: 25px;
}
.context .item-core > :first-child {
  display: inline-block;
  width: 14px;
  height: 14px;
  background: rgba(74, 17, 118, 1);
  border-radius: 50%;
}
.context .item-core :nth-child(2) {
  width: 334px;
  height: 100%;
  text-align: left;
  margin-top: -26px;
  margin-left: 26px;
}
.context p {
  display: inline-block;
  font-size: 14px;
  font-weight: normal;
  color: rgba(51, 51, 51, 1);
}
.context .item-core p {
  display: inline-block;
  font-size: 14px;
  padding-left: 0px;
  font-weight: normal;
  color: rgba(51, 51, 51, 1);
  line-height: 25px;
}
.context > :last-child :last-child {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/coreCardRight.vue